// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import vueResource from 'vue-resource'
import App from './App'
import router from './router'
import filter from './filter/index'

Vue.config.productionTip = false

Vue.use(vueResource);
filter();
// ??
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
});

// 埋点js
$.loadScript({
  loadGa: true,
  loadComplete: function loadComplete() {
    $(document).delegate("*[name^=o2o_]", "click", function () {
      try {
        sa.click.sendDatasIndex(this);
      } catch (e) {
      }
    });
  }
});

window.eventDefault = function (e) {
  e.preventDefault();
};



// WEBPACK FOOTER //
// ./src/main.js